import mutations from './mutations'
import actions from './actions'

const state = {
  all_notes: [],
  notes: [],
  note: [],
  deleted_notes: [],
  alerted_note:[]
}

export default {
  state, mutations, actions
}